import PropTypes from "prop-types";
import React from "react";
import {
  TabsContent,
  TabWrap
} from "../styles";

class TabsAdvisorSuccessor extends React.Component {
  
  render() {
    return (
      <TabWrap className="tabwrap" id={this.props.advisor === 'Primary Advisor'? 'tbPrimaryAdvisor': 'tbSecondaryAdvisor'}>
        <TabsContent>{this.props.advisor}</TabsContent>
      </TabWrap>
    );
  }
}

TabsAdvisorSuccessor.propTypes = {
  advisor: PropTypes.string
};

export default TabsAdvisorSuccessor;
